import { GetFormattedInventory } from '@/models/InventoryModel'
import { getInventory, getInventoryUploadHistory, getInventoryCsvFile } from '@/services/inventory'
import { InventoryListColConfig } from '@/services/MockData/InventoryList/InventorytColConfig'
import { useQueries } from '@tanstack/react-query'
import { downloadCSVFiles, getDateWithTimeString } from '@/helpers/shadcn/utils'
import { useDataTable } from '@/hooks/useDataTable-hook'
import { useMemo } from 'react'

export const useInventory = () => {

  const { setPageIndex, setSortingObj, setSearchArry, pageIndex, sortingObj, searchArr } = useDataTable()

  const queryParams = useMemo(() => {
    const params = new URLSearchParams()
    if (sortingObj?.column) {
      params.append('sortBy', sortingObj?.column)
      params.append('sortOrder', sortingObj?.direction)
    }
    if (pageIndex) {
      params.append('page', pageIndex)
    }
    return params.toString()
  }, [sortingObj?.column, sortingObj?.direction, pageIndex])

  const defaultSortingObj = Object.keys(queryParams)?.length > 0 ? `&${queryParams}` : `sortBy=modificationDate&sortOrder=DESC&page=${pageIndex}&pageSize=10`

  const [inventoryResult] = useQueries({
    queries: [
      {
        queryKey: ['INVENTORY', defaultSortingObj, searchArr],
        queryFn: () => getInventory(searchArr, defaultSortingObj),
      },
    ],
  });

  const uploadHistoryResult = useQueries({
    queries: [
      {
        queryKey: ['INVENTORY_UPLOAD_HISTORY'],
        queryFn: getInventoryUploadHistory,
      },
    ],
  });

  const onDownloadBtnClick = async selectedIds => {
    const defaultSortingObj = Object.keys(queryParams)?.length > 0 ? `&${queryParams}` : `sortBy=modificationDate&sortOrder=DESC&page=${pageIndex}&pageSize=10`

    const body = {
      "productIds": selectedIds,
      "filters": searchArr,
    }

    const data = await getInventoryCsvFile(body, defaultSortingObj)
    const fileName = `Inventory_${getDateWithTimeString()}`
    downloadCSVFiles(data, fileName)
  }

  const resultsData = useMemo(() => inventoryResult?.data || {}, [inventoryResult?.data])
  const inventoryData = useMemo(() => GetFormattedInventory(resultsData), [resultsData])
  const uploadHistory = uploadHistoryResult?.[0]?.data && uploadHistoryResult?.[0]?.data.data ? uploadHistoryResult?.[0]?.data.data : uploadHistoryResult?.[0]?.data

  return {
    inventoryData,
    inventoryColConfigData: InventoryListColConfig,
    setPageIndex,
    setSortingObj,
    setSearchArry,
    onDownloadBtnClick,
    inventoryUploadHistoryData: uploadHistory || [],
  }
}
